import axiosInstance from "./index.services";

export async function ToggleShowCustomPage({id, IsShow} : {id: string| number, IsShow: boolean}){
  const response = await axiosInstance.patch(`/custompage/${id}/`, {
    is_show: IsShow, 
  }, {
    headers: { "Content-Type": "application/json" },
  });
  return response;
}